import React from "react";
import GardoonehIcon from "../../../assets/images/icons/gardooneh.svg";
import ArchiveIcon from "../../../assets/images/icons/archive.svg";
import GoldenCardIcon from "../../../assets/images/icons/goldenCard.png";
import WordGameIcon from "../../../assets/images/icons/wordGame.png";
import { useNavigate } from "react-router";
import MatchMenuElement from "../../../assets/components/Match/MenuElment";

const menuItems = [
  {
    icon: GardoonehIcon,
    text: "گردونه شانس",
    width: "half",
    link: "/fortuneWheel",
  },
  {
    icon: ArchiveIcon,
    text: "خزانه",
    width: "half",
    link: "/khazane/123",
  },
  {
    icon: GoldenCardIcon,
    text: "کارت طلایی",
    width: "half",
    link: "/goldenCard",
  },
  {
    icon: WordGameIcon,
    text: "کلمه بازی",
    width: "half",
    link: "/wordGame",
    showNew: true,
  },
];

export default function QuestsMenu() {
  const navigate = useNavigate();

  const handleClickMenuItem = (item, index) => {
    const linkItems = ["خزانه", "گردونه شانس", "کارت طلایی","کلمه بازی"];
    if (linkItems.includes(item)) {
      navigate(menuItems[index].link);
    }
  };
  return (
    <>
      <div className="mx-0 my-5 p-0 row justify-content-between">
        {menuItems.map((item, index) => {
          return (
            <div
              key={index}
              className={`${
                item.width === "half"
                  ? index % 2 === 0
                    ? "col-6 pl-2 pr-0"
                    : "col-6 pr-2 pl-0"
                  : "col-12 p-0"
              } m-0`}
            >
              <MatchMenuElement
                elementInfo={item}
                fullWidth={item.width === "full"}
                handleClick={() => handleClickMenuItem(item.text, index)}
                showNew={item.showNew}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
